import { useState } from 'react';
import { useInterval } from 'usehooks-ts';

import aquaLogo from '../../assets/aqua-logo.svg';
import { useGetDealerBranding } from '../../queries/useGetDealerBranding.ts';
import { NavLinkProp } from '../../types.ts';
import isLoggedIn from '../../utils/isLoggedIn.ts';
import NavigationLink from '../NavigationLink/NavigationLink';

import './Header.scss';

interface HeaderProps {
  navigationLinks?: NavLinkProp[];
  useDealerBranding?: boolean;
}

const Header = ({ navigationLinks, useDealerBranding = false }: HeaderProps) => {
  const [showLinks, setShowLinks] = useState(false);
  const { data } = useGetDealerBranding(localStorage.getItem('dealer_id') || '');

  useInterval(() => {
    setShowLinks(isLoggedIn());
  }, 500);

  const returnLogo = () => {
    if (useDealerBranding && data?.dealer_logo_base64) {
      return (
        <img
          src={`data:${data?.dealer_logo_content_type || 'image/png'};base64,${data?.dealer_logo_base64}`}
          aria-label="Dealer logo"
          alt="Dealer logo"
        />
      );
    }

    return <img src={aquaLogo} aria-label="Aqua logo" alt="Aqua logo" />;
  };

  return (
    <header className="header-container">
      {returnLogo()}
      <nav>
        {showLinks &&
          navigationLinks?.map((link, index) => {
            return (
              <NavigationLink
                label={link.label}
                path={link.url}
                key={index}
                className={index === 0 ? '' : 'border-left'}
              />
            );
          })}
      </nav>
    </header>
  );
};

export default Header;
